import styled from "styled-components";
import Logo from "./Logo";
import MainNav from "./MainNav";
import { HiChevronDoubleLeft, HiChevronDoubleRight } from "react-icons/hi2";
import { Button } from "../components/ui/button";
import UserAvatarSidebar from "../features/auth/UserAvatarSidebar";
import ThemedSkeleton from "./ThemedSkeleton";
import { TooltipProvider } from "@/components/ui/tooltip";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { useUiStore } from "@/stores/UiStore";
import { CrispChat } from "./CrispChat";

const StyledSidebar = styled.aside`
  background-color: var(--gray-50);
  padding: 3.2rem 1rem;
  border-right: 1px solid var(--gray-200);
  grid-row: 1/ -1;
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
  overflow: hidden;
  position: sticky;
  top: 0;
  height: 100vh;
  transition: all 0.3s;
  box-shadow: var(--shadow-md);
  z-index: 1;
`;

function Sidebar({ isLoading }) {
  const sidebarExpanded = useUiStore((state) => state.sidebarExpanded);
  const toggleSidebar = useUiStore((state) => state.toggleSidebarExpanded);

  return (
    <StyledSidebar>
      <Logo />
      <MainNav expanded={sidebarExpanded} isLoading={isLoading} />
      <CrispChat isIconOnly={!sidebarExpanded} />
      {isLoading ? (
        <div className="relative flex items-center gap-4  mt-auto">
          <ThemedSkeleton className="h-8 w-8 rounded-full" />
          <ThemedSkeleton className="absolute w-4/6" />
        </div>
      ) : (
        <div className="flex flex-col mt-auto space-y-8">
          <div
            className={`flex ${
              !sidebarExpanded && "flex-col"
            }  justify-between mt-auto`}
          >
            <>
              <UserAvatarSidebar />
              <TooltipProvider delayDuration={300}>
                <Tooltip>
                  <TooltipTrigger asChild>
                    <Button
                      onClick={toggleSidebar}
                      variant="ghost"
                      className="mb-0.5 self-end"
                    >
                      {sidebarExpanded ? (
                        <>
                          <HiChevronDoubleLeft />
                          <TooltipContent>
                            <p>Collapse sidebar</p>
                          </TooltipContent>
                        </>
                      ) : (
                        <>
                          <HiChevronDoubleRight />
                          <TooltipContent side="right">
                            <p>Expand sidebar</p>
                          </TooltipContent>
                        </>
                      )}
                    </Button>
                  </TooltipTrigger>
                </Tooltip>
              </TooltipProvider>
            </>
          </div>
        </div>
      )}
    </StyledSidebar>
  );
}

export default Sidebar;
